import { render } from "./CloseTab.vue?vue&type=template&id=b597307e"
import script from "./CloseTab.vue?vue&type=script&lang=js"
export * from "./CloseTab.vue?vue&type=script&lang=js"

import "./CloseTab.vue?vue&type=style&index=0&id=b597307e&lang=scss"

import exportComponent from "C:\\development\\AdmicomWeb\\AdmicomWeb.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__